/**
 * Zapamietywanie postepu scenariusza szkoleniowego.
 *
 * Powod (zgloszenie amwar162, 2026-08-11): scenariusz zapisywal sie na serwerze DOPIERO
 * w calosci, przez `submit-scenario` na samym koncu. Kroki posrednie lecialy na
 * `apiPreviewScenarioStep`, ktory tylko ocenia odpowiedzi i NIC nie zapisuje. Kto wyszedl
 * w polowie — po powrocie zaczynal calosc od nowa. W polaczeniu z modalem „Dziekujemy"
 * bez rozroznienia wyniku ludzie wychodzili przekonani, ze maja zaliczone.
 *
 * Trzymamy postep w `localStorage` przegladarki, kluczowany UZYTKOWNIKIEM i szkoleniem —
 * tablet na hali bywa wspoldzielony, wiec postep jednej osoby nie moze trafic do drugiej.
 * To rozwiazanie po stronie urzadzenia: kto wroci na INNYM sprzecie, zacznie od poczatku
 * (docelowe rozwiazanie to zapis etapow po stronie serwera — osobny temat, wymaga migracji).
 *
 * Wpis wygasa po 21 godzinach: szkolenie wraca sie tego samego dnia albo nastepnego rano,
 * a tydzien stary postep bylby myleniem uzytkownika, nie pomoca.
 */

const PREFIKS = 'lt-scenario-progress';
const WAZNOSC_MS = 21 * 60 * 60 * 1000;

function klucz(userId, trainingId) {
    return `${PREFIKS}:${userId}:${trainingId}`;
}

function magazyn() {
    try {
        // Prywatne okno / wylaczone ciasteczka potrafia rzucic samym dostepem do localStorage.
        const test = `${PREFIKS}:test`;
        window.localStorage.setItem(test, '1');
        window.localStorage.removeItem(test);
        return window.localStorage;
    } catch (e) {
        return null;
    }
}

/**
 * Zapisuje postep po ZALICZONYM etapie. Nie wolawac dla etapu obinionego — wracamy
 * wtedy do tego samego etapu, a nie do nastepnego.
 */
export function zapiszPostep(userId, trainingId, { stepIndex, answersByStep }) {
    const ls = magazyn();
    if (!ls || !userId || !trainingId) {
        return;
    }
    try {
        ls.setItem(klucz(userId, trainingId), JSON.stringify({
            stepIndex,
            answersByStep,
            zapisano: Date.now(),
        }));
    } catch (e) {
        // Brak miejsca albo tryb prywatny — postep jest udogodnieniem, nie warunkiem
        // ukonczenia szkolenia. Cisza jest tu wlasciwa, byle nie wywrocic odtwarzacza.
    }
}

/**
 * Zwraca zapamietany postep albo null. Rozroznia „nie ma wpisu" od „wpis pusty":
 * stepIndex === 0 jest poprawna wartoscia, ale nie ma sensu jako wznowienie.
 */
export function odczytajPostep(userId, trainingId) {
    const ls = magazyn();
    if (!ls || !userId || !trainingId) {
        return null;
    }
    try {
        const surowe = ls.getItem(klucz(userId, trainingId));
        if (!surowe) {
            return null;
        }
        const dane = JSON.parse(surowe);
        if (!dane || typeof dane.stepIndex !== 'number' || dane.stepIndex <= 0) {
            return null;
        }
        if (!dane.zapisano || Date.now() - dane.zapisano > WAZNOSC_MS) {
            ls.removeItem(klucz(userId, trainingId));
            return null;
        }
        return {
            stepIndex: dane.stepIndex,
            answersByStep: (dane.answersByStep && typeof dane.answersByStep === 'object') ? dane.answersByStep : {},
        };
    } catch (e) {
        return null;
    }
}

/** Kasuje postep — po ukonczeniu szkolenia albo gdy uzytkownik wybral start od nowa. */
export function wyczyscPostep(userId, trainingId) {
    const ls = magazyn();
    if (!ls || !userId || !trainingId) {
        return;
    }
    try {
        ls.removeItem(klucz(userId, trainingId));
    } catch (e) {
        // jw.
    }
}
